import Detail from './Detail'
// import Form from './Form'

const InfoDiverses = {
  Detail,
  // Form
}

export default InfoDiverses